import { graphql, useStaticQuery } from 'gatsby';

const usePartnerSectionData = () => {
  const data = useStaticQuery(
    graphql`
      query PARTNERSECTION_DATA_QUERY {
        markdownRemark(frontmatter: { templateKey: { eq: "partners-section" } }) {
          frontmatter {
            title
            labels {
              title
              offer
              id
            }
            partners {
              logos {
                image {
                  childImageSharp {
                    fixed(width: 150, quality: 64) {
                      ...GatsbyImageSharpFixed_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
  );
  return data.markdownRemark.frontmatter;
};

export default usePartnerSectionData;
